<template>
  <columns v-if="!$_.isEmpty(productFields)" class="has-margin-bottom-0">
    <column class="is-12 is-relative">
      <b-loading :active="isLoading" :is-full-page="false" />
      <template v-for="(field, index) in productFields">
        <provision-field
          :key="`provision-field-${index}`"
          v-model="provisionFieldValues[field.name]"
          v-bind="getSemanticBindings(field)"
          :field-id="`provision_field_values.${field.name}`"
          :field-values="provisionFieldValues"
          :field="field"
          :is-disabled="isDisabled"
          :replace-semantic-types="true"
        />
      </template>
    </column>
  </columns>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HasValidation from "@/mixins/HasValidation";
import { SemanticTypes } from "@/data/constants";
import type { PropType } from "vue";
import type {
  IBasketProvisioningFieldsForm,
  IBlueprintField
} from "@/models/provisioning";

export default defineComponent({
  name: "ProductProvisionFields",
  components: {
    "provision-field": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/provisionField.vue"
      )
  },
  mixins: [HasValidation],
  props: {
    value: {
      type: Object as PropType<
        IBasketProvisioningFieldsForm["provision_field_values"]
      >,
      required: true
    },
    productFields: {
      type: Array as PropType<IBlueprintField[]>,
      required: true
    },
    isDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, required: true }
  },
  computed: {
    provisionFieldValues: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    getSemanticBindings(field: IBlueprintField) {
      switch (field.semantic_type) {
        case SemanticTypes.DOMAIN_NAMES:
          return {
            ...this.$_.pick(this.$attrs, [
              "account-id",
              "basket-id",
              "client-id",
              "currency-id",
              "coupons",
              "prices-message"
            ])
          };
        default:
          return {};
      }
    }
  }
});
</script>
